import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { DesktopView, MobileView } from './views';

export const PageContainer: React.FC = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <DesktopView />;
  }

  return <MobileView />;
};
